export default __webpack_public_path__ + "sibelius.c206d9ec.png";